// extracted by mini-css-extract-plugin
export default {"VerifiedIcon":"MarketplaceItem-module__VerifiedIcon__mNjDW3d","Label":"MarketplaceItem-module__Label__Kgi57Nd"};